import { createFileRoute } from "@tanstack/react-router"

import { AssetTypeSettingsGeneralView } from "../../../../../../../../views/AssetTypeSettingsGeneralView/AssetTypeSettingsGeneralView"
import { assetTypeGeneralViewStaticData } from "../../../../../../../../views/AssetTypeSettingsGeneralView/constants"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/general",
)({
	component: AssetTypeSettingsGeneralView,
	staticData: assetTypeGeneralViewStaticData,
})
